import { ConversationRatedV2Payload } from 'apis/auditLogs/types/resources/conversationsAuditLogs.types';

export function getRatingTypeText(
  ratingType: ConversationRatedV2Payload['rating_type'],
): string {
  switch (ratingType) {
    case 'Nps':
      return 'NPS';
    case 'ThumbsUpOrDown':
      return 'Thumbs up or down';
    case 'Csat':
      return 'CSAT';
    default:
      return 'Unknown type';
  }
}
